import Home from "../pages/Home";
// import Overview from "@pages/Overview";
import QRcode from "../pages/QRcode";
import Help from "../pages/Help";
// import StatisticsSummary from "@pages/StatisticsSummary";
import NewStatisticsSummary from "../pages/StatisticsSummary/NewStatisticsSummary";
import StatisticsSummaryNew from "../pages/StatisticsSummaryNew/NewStatisticsSummary";
// import BuyVolumeChannel from "@pages/BuyVolumeChannel";
import UserManage from "@pages/UserManage";
import ChannelManage from "@pages/ChannelManage";
import GameBill from "@pages/GameBill";
import ChannelBill from "@pages/ChannelBill";
import PartnerManage from "@pages/PartnerManage";
// import Settle from "@pages/Settle";
import SettleDetail from "@pages/Settle/SettleDetail.jsx";
import RecommendGame from "@pages/RecommendGame";

/* 
	Overview      = "overview"       //渠道概览
	QRCode        = "qr_code"        //推广二维码
	Help          = "help"           //接入帮助
	ChannelOrder  = "channel_order"  //渠道订单
    Statistics    = "statistics"     //统计汇总
    BuyVolumeChannel = "buy_volume_channel" // 买量渠道统计
	GameBill      = "game_bill"      //游戏账单
	ChannelBill   = "channel_bill"   //渠道账单
	GameManage    = "game_manage"    //游戏管理
    ChannelManage = "channel_manage" //渠道管理
    RecommendGame = "recommend_game" // 游戏推荐
    UserManage    = "user_manage"    //用户管理
    PartnerManage = "partner_manage" // 合作方管理
    Settle = "settle" // 结算
*/

export default {
  menus: [
    // 菜单相关路由
    {
      key: "/cps/index",
      title: "首页",
      icon: "mobile",
      component: Home,
    },
    // 产品要求隐藏
    // {
    //     key: "/cps/overview",
    //     title: "渠道总览",
    //     icon: "bar-chart",
    //     component: Overview,
    //     permissionName: "overview"
    // },
    {
      key: "/cps/QRcode",
      title: "生成二维码",
      icon: "barcode",
      component: QRcode,
      permissionName: "qr_code",
    },
    {
      key: "/cps/help",
      title: "接入帮助",
      icon: "question",
      component: Help,
      permissionName: "help",
    },
    {
      key: "/cps/statistics",
      title: "统计汇总",
      icon: "database",
      component: NewStatisticsSummary,
      permissionName: "statistics",
    },
    {
      key: "/cps/statisticsNew",
      title: "统计汇总-新",
      icon: "database",
      component: StatisticsSummaryNew,
      permissionName: "statistics",
    },
    // {
    //   key: "/cps/volumechannel",
    //   title: "买量渠道统计",
    //   icon: "dollar",
    //   component: BuyVolumeChannel,
    //   permissionName: "buy_volume_channel",
    // },
    {
      key: "/cps/gamebill",
      title: "游戏账单",
      icon: "money-collect",
      component: GameBill,
      permissionName: "game_bill",
    },
    {
      key: "/cps/channelbill",
      title: "渠道账单",
      icon: "money-collect",
      component: ChannelBill,
      permissionName: "channel_bill",
    },
    {
      key: "/cps/channelmanage",
      title: "渠道管理",
      icon: "ordered-list",
      component: ChannelManage,
      permissionName: "channel_manage",
    },
    {
      key: "/cps/recommendgame",
      title: "游戏推荐",
      icon: "heart",
      component: RecommendGame,
      permissionName: "recommend_game",
      // hasBadge: true
    },
    {
      key: "/cps/partnermanage",
      title: "合作方管理",
      icon: "usergroup-add",
      component: PartnerManage,
      permissionName: "partner_manage",
    },
    // {
    //   key: "/cps/settle",
    //   title: "结算",
    //   icon: "pay-circle",
    //   component: Settle,
    //   permissionName: "settle",
    // },
    {
      key: "/cps/usermanage",
      title: "用户管理",
      icon: "user",
      component: UserManage,
      permissionName: "user_manage",
    },
  ],
  others: [
    // 非菜单相关路由
    {
      key: "/cps/settle/detail",
      component: SettleDetail,
      permissionName: "settle",
    },
  ],
};

